import React, { useMemo, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    getGroups,
    getExecutersRequest,
    getAllExecReq,
    getAllExecReqByID,
} from 'redux/datasource/dataSourceSlice';
import {
    getExecutersData,
    getAllGroups,
    getExecutedDatasByID,
    executedAllRequestByID,
    executedAllRequest,
} from 'redux/datasource/dataSourceActions';
import { useSelector } from 'react-redux';
import { useCommonInits } from 'hooks/useCommonInits';
import { getUser, getUnitIds } from 'redux/auth/authSlice';
import {
    Grid,
    Typography,
    Paper,
    FormControl,
    Select,
    MenuItem,
    Button,
} from '@mui/material';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import { ROUTE_PATHS } from 'app/utils/route';

export const PriceExecStatic = () => {
    const user = useSelector(getUser);
    const { dispatch, navigate } = useCommonInits();
    const [pageSize, setPageSize] = useState(10);
    const executeData = useSelector(getAllExecReq);
    const executeDataById = useSelector(getAllExecReqByID);

    const getGroup = useSelector(getGroups);
    const units = useSelector(getUnitIds);
    const unitIds = JSON.parse(units);
    // const filteredGroups = executeData?.filter(val => {
    //     return unitIds.find(a => {
    //         return val.group_name === a;
    //     });
    // });
    const filteringData = getGroup?.filter(val => {
        return unitIds.find(a => {
            return val.name === a;
        });
    });
    const [group, setGroup] = useState('ALL');

    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };

    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 2;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                // width: '22%',
            },
        },
    };

    useEffect(() => {
        dispatch(executedAllRequest());
        dispatch(getAllGroups());
    }, []);

    const handleRowClick = _id => {
        if (user.app_type.includes('APCM_Executor')) {
            navigateTo(
                `/${ROUTE_PATHS.executorLogsByID}/${_id}`, //executed logs by id
            );
        }
    };

    const getFilteredData = () => {
        if (user.app_type.includes('APCM')) {
            if (group === 'ALL') {
                return executeData;
            } else {
                return executeData.filter(data => data.group_name === group);
            }
        } else {
            if (group === 'ALL') {
                return executeDataById;
            } else {
                return executeDataById.filter(
                    data => data.group_name === group,
                );
            }
        }
    };

    useEffect(() => {
        if (!user.app_type.includes('APCM')) {
            if (getGroup) {
                const params = {
                    group_id: filteringData.map(group => group._id),
                };
                dispatch(executedAllRequestByID(params));
            }
        }
    }, [getGroup]);

    const columns = useMemo(
        () => [
            {
                field: 'date_time',
                headerName: 'Date Time For Execution',
                width: 350,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.date_time}
                        </Typography>
                    );
                },
            },
            {
                field: 'group_name',
                headerName: 'Group Name',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.group_name}
                        </Typography>
                    );
                },
            },
            {
                field: 'price_request_name',
                headerName: 'Price Request Name',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.price_request_name}
                        </Typography>
                    );
                },
            },
            {
                field: 'old_price',
                headerName: 'Old Price',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.old_price}
                        </Typography>
                    );
                },
            },
            {
                field: 'price',
                headerName: 'New Price',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.price}
                        </Typography>
                    );
                },
            },
            {
                field: 'executed',
                headerName: 'Executed',
                width: 150,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.confirmed}
                        </Typography>
                    );
                },
            },
        ],
        [],
    );

    return (
        <div>
            <Paper sx={{ margin: 2 }}>
                <div>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        sx={{ p: 2 }}
                    >
                        <Grid item>
                            <RequestPageIcon fontSize="large" />
                        </Grid>
                        <Grid item sx={{ pl: 1 }}>
                            <Typography variant="h5">
                                Executed Price Requests
                            </Typography>
                        </Grid>
                    </Grid>
                    <label style={{ marginLeft: '20px', marginRight: '5px' }}>
                        Groups :
                    </label>
                    <FormControl>
                        <Select
                            size="small"
                            value={group || 'ALL'}
                            onChange={e => setGroup(e.target.value)}
                            sx={{
                                width: 250,
                                marginBottom: '5px',
                                marginRight: '5px',
                            }}
                            MenuProps={MenuProps}
                        >
                            <MenuItem value={'ALL'}>ALL</MenuItem>
                            {user.app_type.includes('APCM')
                                ? getGroup.map(item => {
                                      return (
                                          <MenuItem
                                              value={item.name}
                                              key={`interval-${item.name}`}
                                          >
                                              {item.name}
                                          </MenuItem>
                                      );
                                  })
                                : filteringData.map(item => {
                                      return (
                                          <MenuItem
                                              value={item.name}
                                              key={`interval-${item.name}`}
                                          >
                                              {item.name}
                                          </MenuItem>
                                      );
                                  })}
                        </Select>
                    </FormControl>
                </div>
            </Paper>

            <Paper sx={{ margin: 2 }}>
                <DataGrid
                    disableColumnMenu
                    rows={getFilteredData()}
                    columns={columns}
                    getRowId={row => row._id}
                    rowsPerPageOptions={[10, 25, 50]}
                    autoHeight={true}
                    pageSize={pageSize}
                    onPageSizeChange={newPage => setPageSize(newPage)}
                    getRowSpacing={params => ({
                        top: params.isFirstVisible ? 0 : -2,
                        bottom: params.isLastVisible ? 0 : -2,
                    })}
                />
            </Paper>
        </div>
    );
};
